import classnames from 'classnames';

const imageClasses = {
  hoodie: {
    default: 'bg-hoodie hover:bg-hoodie-hover',
    hover: 'bg-hoodie-hover',
  },
  kids: {
    default: 'bg-kids hover:bg-kids-hover',
    hover: 'bg-kids-hover',
  },
  mens: {
    default: 'bg-mens hover:bg-mens-hover',
    hover: 'bg-mens-hover',
  },
  pulloverhoodie: {
    default: 'bg-pulloverhoodie hover:bg-pulloverhoodie-hover',
    hover: 'bg-pulloverhoodie-hover',
  },
  sticker: {
    default: 'bg-sticker hover:bg-sticker-hover',
    hover: 'bg-sticker-hover',
  },
  sweater: {
    default: 'bg-sweater hover:bg-sweater-hover',
    hover: 'bg-sweater-hover',
  },
  womens: {
    default: 'bg-womens hover:bg-womens-hover',
    hover: 'bg-womens-hover',
  },
  zoom: {
    default: 'bg-zoom hover:bg-zoom-hover',
    hover: 'bg-zoom-hover',
  },
  '3xl': {
    default: 'bg-3xl hover:bg-3xl-hover',
    hover: 'bg-3xl-hover',
  },
};

export const ProductTypesButtonGroup = ({
  active,
  onChange,
  types,
  className,
}) => (
  <div className={classnames('flex', className)}>
    {types.slice(0, 7).map(({ name }, index) => (
      <button
        key={index}
        onClick={() => onChange(index)}
        className={classnames(
          'w-10 h-10 bg-no-repeat bg-center my-1 mr-0.5 border-none',
          imageClasses[name].default,
          {
            [imageClasses[name].hover]: active === index,
          }
        )}
      />
    ))}
  </div>
);
